/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Metaindex_Title1Inputs */

const id_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi | egdata.app`)
};

const ms_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi | egdata.app`)
};

const da_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlinger | egdata.app`)
};

const de_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammlungen | egdata.app`)
};

const en_us2_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections | egdata.app`)
};

const es_es2_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecciones | egdata.app`)
};

const es_mx2_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecciones | egdata.app`)
};

const fil_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Koleksyon | egdata.app`)
};

const fr_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections | egdata.app`)
};

const it_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collezioni | egdata.app`)
};

const hu_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyűjtemények | egdata.app`)
};

const nl_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collecties | egdata.app`)
};

const no_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlinger | egdata.app`)
};

const pl_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekcje | egdata.app`)
};

const pt_br2_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleções | egdata.app`)
};

const pt_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleções | egdata.app`)
};

const ro_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecții | egdata.app`)
};

const fi_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokoelmat | egdata.app`)
};

const sv_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingar | egdata.app`)
};

const vi_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ sưu tập | egdata.app`)
};

const tr_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksiyonlar | egdata.app`)
};

const cs_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekce | egdata.app`)
};

const bg_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекции | egdata.app`)
};

const ru_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подборки | egdata.app`)
};

const uk_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекції | egdata.app`)
};

const ar_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعات | egdata.app`)
};

const hi_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कलेक्शन | egdata.app`)
};

const th_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอลเล็กชัน | egdata.app`)
};

const ja_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクション | egdata.app`)
};

const zh_cn2_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集 | egdata.app`)
};

const zh_hant1_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集 | egdata.app`)
};

const ko_collections_metaindex_title1 = /** @type {(inputs: Collections_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컬렉션 | egdata.app`)
};

/**
* | output |
* | --- |
* | "Collections \| egdata.app" |
*
* @param {Collections_Metaindex_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_metaindex_title1 = /** @type {((inputs?: Collections_Metaindex_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Metaindex_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_metaindex_title1(inputs)
	if (locale === "ms") return ms_collections_metaindex_title1(inputs)
	if (locale === "da") return da_collections_metaindex_title1(inputs)
	if (locale === "de") return de_collections_metaindex_title1(inputs)
	if (locale === "en-US") return en_us2_collections_metaindex_title1(inputs)
	if (locale === "es-ES") return es_es2_collections_metaindex_title1(inputs)
	if (locale === "es-MX") return es_mx2_collections_metaindex_title1(inputs)
	if (locale === "fil") return fil_collections_metaindex_title1(inputs)
	if (locale === "fr") return fr_collections_metaindex_title1(inputs)
	if (locale === "it") return it_collections_metaindex_title1(inputs)
	if (locale === "hu") return hu_collections_metaindex_title1(inputs)
	if (locale === "nl") return nl_collections_metaindex_title1(inputs)
	if (locale === "no") return no_collections_metaindex_title1(inputs)
	if (locale === "pl") return pl_collections_metaindex_title1(inputs)
	if (locale === "pt-BR") return pt_br2_collections_metaindex_title1(inputs)
	if (locale === "pt") return pt_collections_metaindex_title1(inputs)
	if (locale === "ro") return ro_collections_metaindex_title1(inputs)
	if (locale === "fi") return fi_collections_metaindex_title1(inputs)
	if (locale === "sv") return sv_collections_metaindex_title1(inputs)
	if (locale === "vi") return vi_collections_metaindex_title1(inputs)
	if (locale === "tr") return tr_collections_metaindex_title1(inputs)
	if (locale === "cs") return cs_collections_metaindex_title1(inputs)
	if (locale === "bg") return bg_collections_metaindex_title1(inputs)
	if (locale === "ru") return ru_collections_metaindex_title1(inputs)
	if (locale === "uk") return uk_collections_metaindex_title1(inputs)
	if (locale === "ar") return ar_collections_metaindex_title1(inputs)
	if (locale === "hi") return hi_collections_metaindex_title1(inputs)
	if (locale === "th") return th_collections_metaindex_title1(inputs)
	if (locale === "ja") return ja_collections_metaindex_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_metaindex_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_metaindex_title1(inputs)
	return ko_collections_metaindex_title1(inputs)
});
export { collections_metaindex_title1 as "collections.metaIndex.title" }